module.exports = __webpack_public_path__ + "img/WSLogo.807edfe1.png";